export default "__VITE_ASSET__BKEPK7Qj__"